import { createStore, applyMiddleware, compose, combineReducers, } from 'redux'
import thunk from 'redux-thunk'
// import { persistStore, autoRehydrate, } from 'redux-persist'
import { persistStore, } from 'redux-persist'
import createHistory from 'history/createBrowserHistory'
import { connectRoutes, } from 'redux-first-router'

import reducers from './reducers'
import routesMap from './routesMap'
import analyticsMiddleware from './middleware/analytics'

export default () => {
  const history = createHistory()
  const { reducer, middleware, enhancer, } = connectRoutes(history, routesMap)

  const rootReducer = combineReducers({
    ...reducers,
    location: reducer,
  })

  const middlewares = applyMiddleware(middleware, thunk, analyticsMiddleware())
  /* eslint-disable-next-line no-underscore-dangle */
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  // turn off auto rehydration of state for now, as data is not loaded from external source
  // re-think this when we do pull from external source (as part of a proper caching strategy)
  // const store = createStore(rootReducer, composeEnhancers(enhancer, middlewares, autoRehydrate()))
  const store = createStore(
    rootReducer,
    composeEnhancers(enhancer, middlewares)
  )
  persistStore(store)

  return store
}



// WEBPACK FOOTER //
// ./src/redux/createStore.js